import img1 from "../../assets/Lead-image.png"




export const topcharts = [
    {
      title: "Golden age of 80's",
      artist: "Sean swadder",
      time:
        "2:34:45",
      img: <img className="tyu" src={img1} alt="img" />,
    },
    {
        title: "Reggae 'n' blues",
        artist: "Dj yk mule",
        time:
          "1:02:42",
        img:  <img src={img1} alt="img" />,
      },
      {
        title: "Tomorrow's tunes",
        artist: "obi dotti",
        time:
          "2:01:25",
        img:  <img src={img1} alt="img" />,
      },
      {
        title: "filled with blues",
        artist: "Dj sick",
        time:
          "2:34:45",
        img:  <img src={img1} alt="img" />,
      },
 
  ];
  